import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ImmomioSelect } from '@immomio/ui/select';
import { TranslatePipe } from '@ngx-translate/core';
import { ContractIconPipe, ContractNamePipe, IContract } from '@resident-nx/shared';
import { IconWebComponent } from '../icon/icon.component';

// Renders a contract dropdown, or just the contract's name when there is nothing to choose from.
@Component({
  selector: 'rs-web-contract-picker',
  templateUrl: './contract-picker.component.html',
  styleUrl: './contract-picker.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    ImmomioSelect,
    TranslatePipe,
    ContractNamePipe,
    ContractIconPipe,
    IconWebComponent,
  ],
})
export class ContractPickerComponent {
  protected readonly singleContract = computed(() =>
    this.contracts().length === 1 ? this.contracts()[0] : null
  );
  protected readonly hasUnreadContracts = computed(() =>
    this.contracts().some(contract => this.unreadContractIds().includes(contract.id))
  );

  readonly contracts = input.required<(IContract & { disabled?: boolean })[]>();
  readonly contractId = model<string>();
  // Contracts with unread items get a notification bubble.
  readonly unreadContractIds = input<string[]>([]);
}
